// extracted by mini-css-extract-plugin
export default {"container":"container__PZ9hl","chart":"chart__Iwbcp","menu":"menu__DVP1b","hondButton":"hondButton__fZgxR","katButton":"katButton__hMYgS","naam":"naam__a5cad","titel":"titel__GzrIB"};